<ridango-block-full-width>
    <div class="swish-items-area">
        <p class="swish-items-area__title">
            {{'ENTER_PHONE_NUMBER' | translate}}</p>
        <div class="swish-items-area__form">
            <div class="swish-items-area__description">
                <span>{{'MOBILE_APP_TO_PAY' | translate}}</span>
            </div>

            <div class="swish-items-area__wrapper">
                <div class="swish-items-area__mobile">
                    <ridango-form-field>
                        <input class="text-input" ridangoInput type="text" [formControl]="swishAccountField"
                            (keyup)="setSwish()" (blur)="setSwish()" name="swishAccount" ridangoUntouchOnFocusout
                            #swishField>
                        <ridango-label>{{'PH_MOBILE_NUMBER' | translate}}</ridango-label>
                        <ridango-error *ngIf="swishAccountField.touched && swishAccountField.hasError('pattern')">
                            {{ 'LOCAL_INPUT_VALIDATION_SWISH' | translate }}
                        </ridango-error>
                    </ridango-form-field>
                </div>
            </div>
        </div>
    </div>
</ridango-block-full-width>